import React, { memo } from 'react';
import { YStack, XStack } from 'tamagui';
import { CobuCard } from '@cobu/ui';

interface CommentShimmerProps {
  isPinned?: boolean;
}

/**
 * CommentShimmer Component
 * 
 * Provides loading skeleton for comments while data is being fetched.
 * Matches the structure of actual comments for smooth loading experience.
 */
const CommentShimmer: React.FC<CommentShimmerProps> = memo(({ isPinned = false }) => {
  return (
    <YStack mx="$4" my="$2">
      <CobuCard
        padding="$4"
        bc="$pinnedCommentGray"
        br="$3"
      >
        <XStack gap="$3">
          {/* Avatar shimmer */}
          <YStack
            w="$4"
            h="$4"
            br='$12'
            bg="$pinnedCommentGray"
          />

          {/* Content shimmer */}
          <YStack f={1} gap="$2">
            {/* User info shimmer */}
            <XStack ai="center" gap="$2">
              <YStack
                w="$8"
                h="$2"
                br="$2"
                bg="$pinnedCommentGray"
              />
              <YStack
                w="$6"
                h="$2"
                br="$2"
                bg="$pinnedCommentGray"
              />
            </XStack>

            {/* Content shimmer */}
            <YStack gap="$1">
              <YStack
                w="90%"
                h="$2"
                br="$2"
                bg="$pinnedCommentGray"
              />
              <YStack
                w="70%"
                h="$2"
                br="$2"
                bg="$pinnedCommentGray"
              />
              <YStack
                w="50%"
                h="$2"
                br="$2"
                bg="$pinnedCommentGray"
              />
            </YStack>

            {/* Reaction shimmer */}
            <XStack ai="center" gap="$3" mt="$2">
              <YStack
                w="$6"
                h="$2"
                br="$2"
                bg="$pinnedCommentGray"
              />
              <YStack
                w="$5"
                h="$2"
                br="$2"
                bg="$pinnedCommentGray"
              />
            </XStack>
          </YStack>
        </XStack>
      </CobuCard>
    </YStack>
  );
});

CommentShimmer.displayName = 'CommentShimmer';

export default CommentShimmer; 